export const ResponseMessage = {
    SAVED_SUCCESS: 'Данные успешно сохранены',
    UPDATED_SUCCESS: 'Данные успешно обновлены',
    TRANSACTION_SUCCESS: 'Баланс обновлен',
};
